import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-0b69a116"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "redCheckoutVue" };
const _hoisted_2 = { class: "container-fluid bg-white p-0 border-bottom" };
const _hoisted_3 = { class: "container" };
const _hoisted_4 = { class: "row mt-3 px-lg-0" };
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "col-12" }, [
    /*#__PURE__*/ _createElementVNode("div", { class: "w-100 d-block" }, [
        /*#__PURE__*/ _createElementVNode("h1", { class: "h2-responsive mb-4 mt-2" }, "Verkauf abschließen")
    ])
], -1));
const _hoisted_6 = { class: "col-12 col-md-7" };
const _hoisted_7 = { class: "row" };
const _hoisted_8 = { class: "col-12 col-md-5" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_sticky_cta_row = _resolveComponent("sticky-cta-row");
    const _component_small_product_overview = _resolveComponent("small-product-overview");
    const _component_address_block = _resolveComponent("address-block");
    const _component_payout_conditions = _resolveComponent("payout-conditions");
    const _component_info_please_select_payout_condition = _resolveComponent("info-please-select-payout-condition");
    const _component_local_store_selection = _resolveComponent("local-store-selection");
    const _component_shipping_options = _resolveComponent("shipping-options");
    const _component_checkout_newsletter_subscription = _resolveComponent("checkout-newsletter-subscription");
    const _component_final_sale_completion = _resolveComponent("final-sale-completion");
    return (_openBlock(), _createElementBlock("main", _hoisted_1, [
        _createVNode(_component_sticky_cta_row, {
            target_element: ".JS_Sticky_Anchor_Confirm_Checkout_RED",
            button_text: "Bestätigen und verkaufen",
            additional_classes: "d-md-none"
        }),
        _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_small_product_overview)
        ]),
        _createElementVNode("div", _hoisted_3, [
            _createElementVNode("section", _hoisted_4, [
                _hoisted_5,
                _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                        _createVNode(_component_address_block),
                        _createVNode(_component_payout_conditions),
                        (!_ctx.anyPayoutSelected && _ctx.localStorePayoutEnabled)
                            ? (_openBlock(), _createBlock(_component_info_please_select_payout_condition, { key: 0 }))
                            : _createCommentVNode("", true),
                        (_ctx.localStorePayoutSelected)
                            ? (_openBlock(), _createBlock(_component_local_store_selection, { key: 1 }))
                            : (_ctx.anyPayoutSelected || !_ctx.localStorePayoutEnabled)
                                ? (_openBlock(), _createBlock(_component_shipping_options, { key: 2 }))
                                : _createCommentVNode("", true),
                        _createVNode(_component_checkout_newsletter_subscription, { checkout_type: "red" })
                    ])
                ]),
                _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", {
                        class: _normalizeClass(["row", {
                                redStepFinal_WrapperSticky_MOBILE: _ctx.isMobile,
                                redStepFinal_WrapperSticky_DESKTOP: !_ctx.isMobile,
                            }])
                    }, [
                        _createVNode(_component_final_sale_completion)
                    ], 2)
                ])
            ])
        ])
    ]));
}
